// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import {BrowserRouter as Router,Link,useLocation} from "react-router-dom";
import {ThreeDots} from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import {Button} from '@material-ui/core';

const defaultUrl="https://signup.viaplay.se/sappa?key1=57&key2=&emailToken=";

const ActivateViaplay = async () => {
  
    const windowUrl = window.location.search;
    let avtal =   window.location.pathname.toLocaleLowerCase().replace('/bitcom/viaplay/','');
    avtal = avtal.replace('bitcom/viaplay','');
    avtal=avtal.replace('/','');

    if(avtal=='' || avtal ==null)
    {
        window.location.href=defaultUrl;
    }
    else
    {
        //window.alert(avtal);
        // let endpoint = 'https://partner.sappa.se/api/viaplay/' + avtal;

        // fetch(endpoint,{headers:{Authorization: '2D6AC8CF-7D30-4963-B429-09459CA23D81'}})
        // .then(response => response.text())
        // .then(data => window.location.href =data)
        // .catch(exp =>window.location.href=defaultUrl);

        //https://signup.viaplay.se/sappa?key1=16&key2={custno}&emailToken=
        window.location.href="https://signup.viaplay.se/sappa?key1=57&key2="+avtal+"&emailToken=";
    }

    
    // const endpoint = 'https://partner.sappa.se/api/viaplay/' + 

    // fetch(apiEndpoint,{headers:{Authorization: '2D6AC8CF-7D30-4963-B429-09459CA23D81'}})
    //     .then(response => response.text())
    //     .then(data => window.location.href =data);
  
//window.location.href="https://signup.viaplay.se/sappa?key1=sappa&key2=&emailToken=";
  
}

function ViaplayActivateBitcom(props) {

    useEffect(() => {
        setTimeout(() => {
            ActivateViaplay();
        }, 1500); 
    },[]);

    return (
      <div className="container">
        
        <header className="App-header">
        <img src={ require('./images/Sappa_Green.png') } />
        <img src={ require('./images/bitcom_logo.png') } />
          <p>
            Startar aktiveringsprocess av Viaplay...
          </p>
          <ThreeDots color="#000000" height={150} width={150}/>
          <img src={ require('./images/ViaplayLogo.jpg') } />
        </header> 
  
      </div>
    );
  }

export default ViaplayActivateBitcom;
